import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function InventoryNavButRealTime( props ){
    //console.debug("RTS Break InventoryNavButRealTime");

    const history = useNavigate();
    const {setCurFilter} = useSessionContext();

    function handleClick(e) {
        setCurFilter(null);
        props.setOpenDrawerFx(false);
        history("/InventoryRealTime");
    }

    if(props.mode==="NavDrawer"){
        return (
            <>
            <ListItem button key="RealTime" onClick={handleClick}>
                <ListItemText primary="Real Time" />
            </ListItem>
            </>
        )
    }

    return (
        <>
        <Button
            key='RealTime'
            onClick={handleClick}
            sx={{ my: 2, mx: 1, color: 'white', textTransform: 'unset' }}
        >
            Real Time
        </Button>
        </>
    );
}



